import { Spinner, useIntl } from '@metsooutotec/modes-react-components';
import { observer } from 'mobx-react-lite';
import React, { useEffect, } from 'react';
import { Outlet } from 'react-router-dom';
import linerMaterialStore from './stores/liner-material-store';

const LinerMaterialLibraryLoader: React.FC = observer(() => {

    const { formatMessage } = useIntl();
    const { linerMaterials, loadAllLinerMaterials, materialTypes } = linerMaterialStore;
    useEffect(() => {
        if (!linerMaterials.length) {
            loadAllLinerMaterials();
        }
    });

    if (!linerMaterials.length || !materialTypes.length) {
        return <Spinner text={formatMessage("linerMaterial.loading")} style={{ zIndex: 8 }} />;
    }
    else {
        return <Outlet />
    }
});
export default LinerMaterialLibraryLoader;